import { DropDownList, DropDownListProps } from '@progress/kendo-react-dropdowns';
import * as React from 'react';
import { IDNameViewModel } from "TypeGen/id-name-view-model";

type RollsRoyceContactDropDownProps = {
  authorizationCustomerContactName: string | null;
  authorizationCustomerContacts: IDNameViewModel[];
  onContactChange: (data: {
    customerContactName: string | null;
  }) => void;
} & DropDownListProps;

const RollsRoyceContactDropDown: React.FC<RollsRoyceContactDropDownProps> = ({
  authorizationCustomerContactName,
  authorizationCustomerContacts,
  onContactChange,
  ...selectProps
}) => {
  const handleContactChange = (e: any) => {
    if (e.value.ID) {
      onContactChange({
        customerContactName: e.value.Name
      });
    } else {
      onContactChange({
        customerContactName: null
      });
    }

    // Call original onChange if provided
    selectProps.onChange?.(e);
  };

  //console.log(authorizationCustomerContactName);

  const defaultItem = { Name: "Select Contact", ID: "" };

  return (
    <DropDownList
      data={[...authorizationCustomerContacts]}
      textField="Name"
      dataItemKey="ID"
      value={authorizationCustomerContacts.find(contact => contact.Name?.toLowerCase() === authorizationCustomerContactName?.toLowerCase()) || defaultItem}
      onChange={handleContactChange}
      defaultItem={defaultItem}
      {...selectProps}
    />
  );
};

export default RollsRoyceContactDropDown;
